import { FunctionComponent } from 'react';
import AccountsList from 'components/account/AccountsList/AccountsList';

const AccountsPage: FunctionComponent = () => <AccountsList />;

export default AccountsPage;
